module.exports = __webpack_public_path__ + "img/visa.a0931f7d.svg";